/** Optional-storage consent. Essential storage (sign-in, preferences) never needs it. */
export type ConsentChoice = "all" | "essential";
const KEY = "swiftix_cookie_consent_v1";
export const CONSENT_EVENT = "swiftix:consent";

export function getConsent(): ConsentChoice | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === "all" || v === "essential" ? v : null;
  } catch {
    return null;
  }
}

export function setConsent(choice: ConsentChoice) {
  try { localStorage.setItem(KEY, choice); } catch { /* storage unavailable */ }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: choice }));
}
